// Localized frame builder for /how-it-works. Call `getFrames(t)` inside a
// component so it re-reads translations whenever the locale changes.
//
// Shape: [{ label, employer: {...}, employee: {...} }]
// Panel shape: { headline, detail, dimmed?, stats?: [[label, value, coral?], ...] }

export function getFrames(t) {
    const raw = t("howItWorks.frames", { returnObjects: true });
    if (!Array.isArray(raw)) return [];
    return raw;
}
